<template lang="pug">
    div.scroll-pane(
        ref="scrollContainer"
        @wheel.prevent="handleScroll"
        :style="{ overflow }"
    )
        div.scroll-wrapper(
            ref="scrollWrapper"
            :style="{ left: left + 'px' }"
        )
            slot
</template>
<script>
// tag's padding
const padding = 15;

export default {
    name: 'ScrollPane',
    props: {
        overflow: {
            type: String,
            default: 'hidden',
        },
    },
    data() {
        return {
            left: 0,
        };
    },
    methods: {
        handleScroll(e) {
            const eventDelta = e.wheelDelta || -e.deltaY * 3;
            const $container = this.$refs.scrollContainer;
            const $containerWidth = $container.offsetWidth;
            const $wrapper = this.$refs.scrollWrapper;
            const $wrapperWidth = $wrapper.offsetWidth;

            if (eventDelta > 0) {
                this.left = Math.min(0, this.left + eventDelta);
                return;
            }

            if ($containerWidth - padding < $wrapperWidth) {
                if (this.left < -(($wrapperWidth - $containerWidth) + padding)) {
                    this.left = this.left;
                } else {
                    this.left = Math.max(this.left + eventDelta, $containerWidth - $wrapperWidth - padding);
                }
            } else {
                this.left = 0;
            }
        },
        moveToTarget($target) {
            const $container = this.$refs.scrollContainer;
            const $containerWidth = $container.offsetWidth;
            const $targetLeft = $target.offsetLeft;
            const $targetWidth = $target.offsetWidth;

            if ($targetLeft < -this.left) {
                // tag in the left
                this.left = -$targetLeft + padding;
            } else if ($targetLeft + padding > -this.left && $targetLeft + $targetWidth < (-this.left + $containerWidth) - padding) {
                // tag in the current view
            } else {
                // tag in the right
                this.left = -(($targetLeft - ($containerWidth - $targetWidth)) + padding);
            }
        },
    },
};
</script>
<style scoped lang="scss" >
    .scroll-pane {
        white-space: nowrap;
        position: relative;
        width: 100%;
        .scroll-wrapper {
            position: absolute;
        }
    }
</style>
